module.exports = __webpack_public_path__ + "static/media/StrikeBlack.bbfe7bdb.svg";